// extracted by mini-css-extract-plugin
export default {"mainCont":"RefTarifTag_mainCont__HGsBe","tableCont":"RefTarifTag_tableCont__zNcWR","btnCont":"RefTarifTag_btnCont__IS82h"};